export * from './src/fancy-image-uploader.component';
export * from './src/uploaded-file';
export * from './src/fancy-image-uploader.module';



//////////////////
// WEBPACK FOOTER
// ./~/ng2-fancy-image-uploader/dist/index.js
// module id = 364
// module chunks = 9